<template>
  <b-modal
    ref="shortcutsAndVoiceCommands"
    size="xl"
    :title="$t('component.helpPopover.shortcutsAndVoiceCommands')"
    centered
    modal-class="shortcuts-modal"
    static
    hide-footer
  >
    <b-row>
      <b-col>
        <div>
          <b-tabs
            v-model="activeTabIndex"
            pills
            card
            vertical
            class="vt-tabs--pills"
          >
            <b-tab active>
              <template slot="title">
                <i
                  class="far fa-globe mr-2"
                  aria-hidden="true"
                />
                {{ $t('component.shortcutsModal.globals') }}
              </template>
              <b-row class="scroll-area">
                <global-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionClinical">
              <template slot="title">
                <i
                  class="far fa-file-medical mr-2"
                  aria-hidden="true"
                />
                {{ $tc('global.request', 2) }}
              </template>
              <b-row class="scroll-area">
                <clinical-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionRequest">
              <template slot="title">
                <i
                  class="far fa-envelope-open-text mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.requestBox') }}
              </template>
              <b-row class="scroll-area">
                <request-box-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionRegistry">
              <template slot="title">
                <i
                  class="far fa-cabinet-filing mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.register') }}
              </template>
              <b-row class="scroll-area">
                <register-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionGrossing">
              <template slot="title">
                <i
                  class="far fa-scalpel-path mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.grossing') }}
              </template>
              <b-row class="scroll-area">
                <grossing-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionLaboratory">
              <template slot="title">
                <i
                  class="far fa-vials mr-2"
                  aria-hidden="true"
                />
                {{ $tc('global.laboratory') }}
              </template>
              <b-row class="scroll-area">
                <laboratory-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionDiagnosis">
              <template slot="title">
                <i
                  class="far fa-file-chart-line mr-2"
                  aria-hidden="true"
                />
                {{ $tc('global.diagnosis') }}
              </template>
              <b-row class="scroll-area">
                <diagnose-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionIncidents">
              <template slot="title">
                <i
                  class="far fa-exclamation-triangle mr-2"
                  aria-hidden="true"
                />
                {{ $tc('entities.incident.incidentsManagement') }}
              </template>
              <b-row class="scroll-area">
                <incidents-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionArchive">
              <template slot="title">
                <i
                  class="far fa-archive mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.archiveManagement') }}
              </template>
              <b-row class="scroll-area">
                <archive-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionWaste">
              <template slot="title">
                <i
                  class="far fa-trash mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.wasteManagement') }}
              </template>
              <b-row class="scroll-area">
                <waste-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionShipments">
              <template slot="title">
                <i
                  class="far fa-box mr-2"
                  aria-hidden="true"
                />
                {{ $t('shipments.sidebar.shipments') }}
              </template>
              <b-row class="scroll-area">
                <shipments-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionAudit">
              <template slot="title">
                <i
                  class="far fa-ballot-check mr-2"
                  aria-hidden="true"
                />
                {{ $t('audit.sidebar.auditTitle') }}
              </template>
              <b-row class="scroll-area">
                <audit-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionConfiguration">
              <template slot="title">
                <i
                  class="far fa-cog mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.config') }}
              </template>
              <b-row class="scroll-area">
                <configuration-help-tab />
              </b-row>
            </b-tab>
            <b-tab v-if="visibleSectionViewer">
              <template slot="title">
                <i
                  class="far fa-images mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.viewer') }}
              </template>
              <b-row class="scroll-area">
                <viewer-help-tab />
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { ModuleOperation } from '@/api/operations/models/module-operation'
import sessionStore from '@/session/sessionStore'
import GlobalHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/GlobalHelpTab'
import ClinicalHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/ClinicalHelpTab'
import RequestBoxHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/RequestBoxHelpTab'
import RegisterHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/RegisterHelpTab'
import GrossingHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/GrossingHelpTab'
import LaboratoryHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/LaboratoryHelpTab'
import DiagnoseHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/DiagnoseHelpTab'
import IncidentsHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/IncidentsHelpTab'
import ArchiveHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/ArchiveHelpTab'
import WasteHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/WasteHelpTab'
import ShipmentsHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/ShipmentsHelpTab'
import AuditHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/AuditHelpTab'
import ConfigurationHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/ConfigurationHelpTab'
import ViewerHelpTab from '@/components/help/shortcutsAndVoiceCommands/helpTabs/ViewerHelpTab'
import { HelperUtils } from '@/shared/util/helper-utils'

const DATA_TAB = 0

export default {
    name: 'ShortcutsAndVoiceCommands',
    components: {
        GlobalHelpTab,
        ClinicalHelpTab,
        RequestBoxHelpTab,
        RegisterHelpTab,
        GrossingHelpTab,
        LaboratoryHelpTab,
        DiagnoseHelpTab,
        IncidentsHelpTab,
        ArchiveHelpTab,
        WasteHelpTab,
        ShipmentsHelpTab,
        AuditHelpTab,
        ConfigurationHelpTab,
        ViewerHelpTab
    },
    props: {
        sample: Object,
        isCaseValidated: Boolean
    },
    data() {
        return {
            sessionState: sessionStore.state,
            moduleOperation: ModuleOperation,
            activeTabIndex: DATA_TAB
        }
    },
    computed: {
        visibleSectionClinical() {
            return HelperUtils.hasModuleAccess(ModuleOperation.PETITIONER)
        },
        visibleSectionRequest() {
            return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY_REQUEST)
        },
        visibleSectionRegistry() {
            return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY)
        },
        visibleSectionGrossing() {
            return HelperUtils.hasModuleAccess(ModuleOperation.GROSSING)
        },
        visibleSectionLaboratory() {
            return HelperUtils.hasModuleAccess(ModuleOperation.LABORATORY)
        },
        visibleSectionDiagnosis() {
            return HelperUtils.hasModuleAccess(ModuleOperation.DIAGNOSE)
        },
        visibleSectionIncidents() {
            return HelperUtils.hasModuleAccess(ModuleOperation.INCIDENT)
        },
        visibleSectionArchive() {
            return HelperUtils.hasModuleAccess(ModuleOperation.ARCHIVE)
        },
        visibleSectionWaste() {
            return HelperUtils.hasModuleAccess(ModuleOperation.WASTE)
        },
        visibleSectionShipments() {
            return HelperUtils.hasModuleAccess(ModuleOperation.SHIPMENTS)
        },
        visibleSectionAudit() {
            return HelperUtils.hasModuleAccess(ModuleOperation.AUDIT)
        },
        visibleSectionConfiguration() {
            return HelperUtils.hasModuleAccess(ModuleOperation.CONFIGURATION)
        },
        visibleSectionViewer() {
            return HelperUtils.hasModuleAccess(ModuleOperation.DIAGNOSE) ||
                HelperUtils.hasModuleAccess(ModuleOperation.GROSSING)
        }
    },
    methods: {
        show() {
            this.$refs.shortcutsAndVoiceCommands.show()
        },
        hide() {
            this.$refs.shortcutsAndVoiceCommands.hide()
        }
    }
}
</script>

<style lang="scss">
    .shortcuts-modal .help-title {
        color: vt-color(primary);
        font-size: font-size(very-normal);
        background: vt-color(white-light) !important;
        z-index: 1;
        position: sticky;
        top: 0;
    }
    .shortcuts-modal .modal-body {
        border-radius: 0.25rem !important;
    }
    .shortcuts-modal .modal-content .card-header {
        background: transparent;
        min-width: 200px;
    }
    .shortcuts-modal .modal-content .tab-content {
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        margin-top: 0 !important;
        box-shadow: 0 2px 5px 0 #9c9c9c;
        margin-left: 10px;
        margin-right: 5px;
        overflow-y: auto;
    }
    .shortcuts-modal .modal-content .tab-scroll-content {
        height: calc(100% - 75px);
        overflow-y: auto;
    }
    .shortcuts-modal .modal-content .tab-scroll-content.without-footer {
        height: calc(100% - 35px);
    }

    .shortcuts-modal .modal-content .tab-pane {
        height: 100%;
    }

    .shortcuts-modal .modal-content .tabs.vt-tabs {
        height: 100% !important;
    }
    .shortcuts-modal .modal-content .tabs .col-auto {
        min-height: 400px;
        height: calc(100vh - 380px);
        overflow-y: auto;
        overflow-x: hidden;
        display: inline-grid;
    }
    .shortcuts-modal .tab-content {
        min-height: 400px;
        height: calc(100vh - 380px);
        overflow-y: auto;
    }
</style>
